module.exports = __webpack_public_path__ + "static/img/avatar_r_18.38483e24.png";